import { FC } from 'react';
import { path } from '@/routes/Routes.helpers';
import IcoCheck from '@/assets/svg/ico_check.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import { MODAL_SHEET_SIZES } from '@/components/interactive/ModalSheet/ModalSheet.config';
import styles from '@/components/widgets/ProgressWidget/LoadCompletedModal/LoadCompletedModal.module.scss';
import { LoadCompletedModalPropsIF } from '@/components/widgets/ProgressWidget/LoadCompletedModal/LoadCompletedModal.types';

const LoadCompletedModal: FC<LoadCompletedModalPropsIF> = ({ onclose }) => (
    <ModalSheet
        size={MODAL_SHEET_SIZES.Small}
        onClose={onclose}
        isHideClose
        dataTest="load_completed_modal"
    >
        <div className={`flcol flc ${styles.modalBody}`}>
            <IcoCheck />
            <span className={styles.content}>
                Ваши изделия успешно
                <br /> загружены. Можете перейти
                <br /> в гардероб для просмотра
            </span>
            <Button
                dataTest="load_completed_close_button"
                clickHandler={() => onclose(path('wardrobeAdd'))}
            >
                К гардеробу
            </Button>
        </div>
    </ModalSheet>
);

export default LoadCompletedModal;
